export enum InputType {
  Text = 'text',
  Password = 'password',
  Email = 'email',
}